import { IconAlert } from '../../icons';
import { Container, IconContainer } from './Alert.styles';

export type AlertTypes = 'error' | 'info' | 'success' | 'warning';

interface AlertProps {
  type: AlertTypes;
  children?: React.ReactNode;
  className?: string;
}

export default function Alert({ type, className, children }: AlertProps) {
  return (
    <Container className={className} type={type}>
      <IconContainer>
        <IconAlert width="24" />
      </IconContainer>
      {children}
    </Container>
  );
}
